// extracted by mini-css-extract-plugin
module.exports = {"key_facts_bar":"key-facts-bar_key_facts_bar___oauh","stat_item":"key-facts-bar_stat_item__g5ulZ","stat_value":"key-facts-bar_stat_value__rxFAX"};